import CustomButton from "../customButtom/CustomButton";

export default function ImageTextCard({
  image,
  label,
  position = "right",
  imageClass = "w-full max-w-[500px] h-auto",
  labelClass = "text-custom-blue font-bold text-2xl sm:text-3xl md:text-4xl",
  descriptionClass = "text-sm sm:text-base font-normal text-custom-gray",
  titleClass = "font-bold text-black text-lg sm:text-xl",
  obj,
  pointIcon,
  pointIconClass,
  subTitle,
  subTitleClass = "text-sm sm:text-base font-normal text-custom-gray",
  buttonText,
  buttonTextClass,
  icon,
  iconClass,
  children,
}) {
  return (
    <div className="p-6 md:p-10 lg:px-20 lg:py-28 flex flex-col xl:flex-row items-center gap-10 xl:gap-16 bg-custom-gray w-full mx-auto max-w-[1500px]">
      {/* Image on Left (for 'left' position) */}
      {position === "left" && (
        <div className="w-full flex justify-center xl:justify-start">
          <img
            src={image}
            alt="Assessment"
            className={`${imageClass} max-w-xs sm:max-w-sm md:max-w-md xl:max-w-lg`}
          />
        </div>
      )}

      {/* Text Content */}
      <div className="w-full max-w-2xl flex flex-col gap-6 text-center xl:text-left">
        <p className={`${labelClass}`}>{label}</p>
        {subTitle && <p className={`${subTitleClass}`}>{subTitle}</p>}

        {/* List Items */}
        <div className="flex flex-col gap-4">
          {obj?.map((item, key) => (
            <div className="flex items-start gap-3" key={key}>
              {pointIcon && (
                <img
                  src={pointIcon}
                  alt="Icon"
                  className={`${pointIconClass}`}
                />
              )}
              <p className={`${titleClass}`}>
                {item?.title}
                <span className={`${descriptionClass} ml-1`}>
                  {item?.description}
                </span>
              </p>
            </div>
          ))}
          {children && <div>{children}</div>}
        </div>

        {/* Button */}
        {buttonText && (
          <div className="flex justify-center xl:justify-start">
            <CustomButton
              label={buttonText}
              buttonClass={buttonTextClass}
              rightIcon={icon}
              rightIconClass={iconClass}
            />
          </div>
        )}
      </div>

      {/* Image on Right (for 'right' position) */}
      {position === "right" && (
        <div className="w-full flex justify-center xl:justify-end">
          <img
            src={image}
            alt="Assessment"
            className={`${imageClass} max-w-xs sm:max-w-sm md:max-w-md xl:max-w-lg`}
          />
        </div>
      )}
    </div>
  );
}
